import { sendEvent } from '../../../configs/firebase'

export type AppointmentCancelSource =
  | 'medical_record_new'
  | 'medical_record_analysis'

export type AppointmentCancelDismissStep = 1 | 2

const appointmentCancelAnalytics = {
  trackCancelModalView(params: {
    schedulingId?: string
    source?: AppointmentCancelSource
  }): void {
    sendEvent('doctor_appointment_cancel_modal_view', {
      schedulingId: params.schedulingId ?? '',
      source: params.source ?? 'unknown',
    })
  },

  trackCancelReasonSelected(params: {
    schedulingId?: string
    source?: AppointmentCancelSource
    reasonKey: string
  }): void {
    sendEvent('doctor_appointment_cancel_reason_selected', {
      schedulingId: params.schedulingId ?? '',
      source: params.source ?? 'unknown',
      reasonKey: params.reasonKey,
    })
  },

  trackCancelDismiss(params: {
    schedulingId?: string
    source?: AppointmentCancelSource
    step: AppointmentCancelDismissStep
  }): void {
    sendEvent('doctor_appointment_cancel_dismiss', {
      schedulingId: params.schedulingId ?? '',
      source: params.source ?? 'unknown',
      step: params.step,
    })
  },

  /** Passo 1: usuário confirmou o motivo e avançou para o aviso final. */
  trackCancelIntent(params: {
    schedulingId?: string
    source?: AppointmentCancelSource
    reasonKey: string
    hasCustomDetail: boolean
  }): void {
    sendEvent('doctor_appointment_cancel_intent', {
      schedulingId: params.schedulingId ?? '',
      source: params.source ?? 'unknown',
      reasonKey: params.reasonKey,
      hasCustomDetail: params.hasCustomDetail,
    })
  },

  /** Passo 2: clique em “Finalizar” antes da chamada à API. */
  trackCancelFinalConfirmClick(params: {
    schedulingId?: string
    source?: AppointmentCancelSource
  }): void {
    sendEvent('doctor_appointment_cancel_final_confirm_click', {
      schedulingId: params.schedulingId ?? '',
      source: params.source ?? 'unknown',
    })
  },

  trackCancelApiSuccess(params: {
    schedulingId: string
    source?: AppointmentCancelSource
    reasonKey: string
    hasCustomDetail: boolean
  }): void {
    sendEvent('doctor_appointment_cancel_api_success', {
      schedulingId: params.schedulingId,
      source: params.source ?? 'unknown',
      reasonKey: params.reasonKey,
      hasCustomDetail: params.hasCustomDetail,
    })
  },

  trackCancelApiFailure(params: {
    schedulingId: string
    source?: AppointmentCancelSource
  }): void {
    sendEvent('doctor_appointment_cancel_api_failure', {
      schedulingId: params.schedulingId,
      source: params.source ?? 'unknown',
    })
  },
}

export default appointmentCancelAnalytics
